import { Link, LinkProps } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import {
	PageHeaderTitleContainer,
	PageHeaderActions,
	PageHeaderContainer,
	PageHeaderBreadcrumbs,
} from 'shared/_components/page/styles';

export type BreadcrumbLink = LinkProps & { label: ReactNode };
export type BreadcrumbItem = ReactNode | BreadcrumbLink;

type PageHeaderProps = PropsWithChildren<{
	breadcrumbs?: BreadcrumbItem[];
	actions?: ReactNode;
}>;

function Breadcrumbs({ items = [], children }: PropsWithChildren<{ items?: BreadcrumbItem[] }>) {
	return (
		<PageHeaderBreadcrumbs separator="»">
			{[...items, children].filter(Boolean).map((bc, i) => {
				const key = i;
				if (bc && typeof bc === 'object' && 'label' in bc) {
					const { label, ...linkProps } = bc as BreadcrumbLink;
					return (
						<Link key={key} {...linkProps}>
							{label}
						</Link>
					);
				}

				return <span key={key}>{bc as ReactNode}</span>;
			})}
		</PageHeaderBreadcrumbs>
	);
}

export default function PageHeader(props: PageHeaderProps) {
	const { children, breadcrumbs = [], actions } = props;

	return (
		<PageHeaderContainer>
			<PageHeaderTitleContainer>
				<Breadcrumbs items={breadcrumbs}>{children}</Breadcrumbs>
				{/* <PageTitle>{children}</PageTitle> */}
			</PageHeaderTitleContainer>
			{!!actions && <PageHeaderActions>{actions}</PageHeaderActions>}
		</PageHeaderContainer>
	);
}
